import { useState, useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router';

import auth from 'utils/auth';
import { InviteToApplyModal } from './InviteToApplyModal';

const isValidCandidate = (id: number) => Number.isInteger(id) && id > 0;

export const InviteToApplyLandingPage: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const candidateId = Number(queryParams.get('candidate_id'));
  const [isModalOpen, setIsModalOpen] = useState(isValidCandidate(candidateId));

  useEffect(() => {
    if (isValidCandidate(candidateId)) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
      history.replace('/principal/candidates');
    }
  }, [candidateId, history]);

  if (!auth.hasConnectIntegrationModule()) {
    return <Redirect to="/principal/candidates" />;
  }

  const handleClose = () => {
    setIsModalOpen(false);
    history.replace('/principal/candidates');
  };

  return (
    <InviteToApplyModal isOpen={isModalOpen} candidateId={candidateId} handleClose={handleClose} />
  );
};
